var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1464 13.3536C9.95118 13.1583 9.95118 12.8417 10.1464 12.6464L14.2929 8.5L0.5 8.5C0.223858 8.5 0 8.27614 0 8C0 7.72386 0.223858 7.5 0.5 7.5L14.2929 7.5L10.1464 3.35355C9.95118 3.15829 9.95118 2.84171 10.1464 2.64645C10.3417 2.45118 10.6583 2.45118 10.8536 2.64645L15.8536 7.64645C15.9015 7.69439 15.9377 7.74964 15.9621 7.80861C15.9865 7.86756 16 7.93221 16 8C16 8.06779 15.9865 8.13244 15.9621 8.19139C15.9377 8.25036 15.9015 8.30561 15.8536 8.35355L10.8536 13.3536C10.6583 13.5488 10.3417 13.5488 10.1464 13.3536Z",
    fill: "#B3B3B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledRight);
export default __webpack_public_path__ + "static/media/disabled-right.fd813b6176a05378f2f24055614700d3.svg";
export { ForwardRef as ReactComponent };